<template>
  <div>
    <div style="margin-top: -21px;margin-left: 4px;white-space: pre-line;">{{ pageDescription }}</div>
    <div class="btn-group-justify-end">
      <div class="button is-primary" @click="submit" v-if="isPartnerAdmin">저장하기</div>
    </div>

    <!-- 탭 -->
    <div class="flex title-group">
      <div class="tab" :class="{'menu-tab': menuTab===1}" @click="menuTab=1">서비스 정보</div>
      <div class="tab" :class="{'menu-tab': menuTab===2}" @click="menuTab=2">사업자/정산 정보</div>
    </div>

    <div class="columns is-multiline">

      <!-- 사업자 정보 -->
      <partner-business :business="business" v-if="menuTab===2"></partner-business>

      <!-- 서비스 기본 정보 -->
      <div class="column is-7" v-if="menuTab===1">

        <div class="box">
          <admin-box-item title="공간 파트너 기본 정보">
            <div class="columns is-multiline">
              <div class="column is-half">
                <admin-form-item label="공간 파트너명*">
                  <input class="input"
                         style="width: 250px"
                         :value="partner.name"
                         @input="e => partner.name = e.target.value"
                         placeholder="공간 파트너명을 입력하세요."
                         type="text">
                </admin-form-item>
              </div>
              <div class="column is-half">
                <admin-form-item label="공간 파트너 대표 전화번호*" :tip="'고객이 전화걸기 버튼을 눌렀을 때 연결되는 번호입니다.\n정확히 입력해주세요.'">
                  <input class="input"
                         style="width: 250px"
                         :value="partner.phone"
                         @input="e => partner.phone = e.target.value"
                         placeholder="010-1234-5678"
                         type="text" maxlength="14">
                </admin-form-item>
              </div>
              <div class="column is-half"
                   v-if="(social_key && social_key.eney && social_key.eney.enable.service && partner.virtual_call_number) && isAdmin">
                <admin-form-item label="공간 파트너 가상 전화번호">
                  <input class="input"
                         style="width: 250px"
                         :value="partner.virtual_call_number"
                         :disabled="true"
                         placeholder="(123)456-7890"
                         type="text" maxlength="13">
                </admin-form-item>
              </div>
              <div class="column is-half"
                   v-if="social_key && social_key.eney && social_key.eney.enable.service && (!is_modify || !partner.virtual_call_number) && isAdmin">
                <admin-form-item label="공간 파트너 가상 전화번호">
                  <input class="input"
                         style="width: 250px"
                         :value="able_virtual_call_number"
                         :disabled="true"
                         placeholder="(123)456-7890"
                         type="text" maxlength="13">
                </admin-form-item>
              </div>
              <div class="column is-half">
                <admin-form-item label="이메일*">
                  <input class="input"
                         style="width:250px"
                         :value="partner.email"
                         @input="e => partner.email = e.target.value"
                         placeholder="launchpack@launchpack.co.kr"
                         type="text" maxlength="40">
                </admin-form-item>
              </div>
              <!--<div class="column is-half">
                <admin-form-item label="홈페이지 URL">
                  <input class="input"
                         style="width:250px"
                         :value="partner.homepage"
                         @input="e => partner.homepage = e.target.value"
                         placeholder="https://"
                         type="text" maxlength="200">
                </admin-form-item>
              </div>
              <div class="column is-half">
                <admin-form-item label="카카오 채널 id">
                  <input class="input"
                         style="width:250px"
                         :value="partner.kakao_channel_id"
                         @input="e => partner.kakao_channel_id = e.target.value"
                         placeholder="_xcLqmC"
                         type="text" maxlength="20">
                </admin-form-item>
              </div>-->
              <div class="column is-7">
                <admin-form-item label="주소">
                  <lp-address :data.sync="partner.address"></lp-address>
                </admin-form-item>
              </div>
              <div class="column is-full">
                <admin-form-item label="서비스 가능 지역" tip="공간 파트너의 주소와 무관하게 서비스 가능한 지역을 추가적으로 선택할 수 있는 기능입니다.
Prime고객 외에는 사용되지 않고 있으며 고객 요청 및 정책에 따라 추후 Basic, Start-up 멤버십에도 적용할 수 있습니다.">
                  <div class="modal-address">
                    <div v-for="(tag,idx) in partner.able_address"
                         :key="'addr-'+idx"
                         class="modal-tag">{{ tag.full_text }}
                      <i class="unselect material-icons" @click="delTag(idx)">close</i>
                    </div>

                    <div style="position: relative;flex:1;min-width:150px">
                      <input :value="map_region" @input="e => mapping(e.target.value)"
                             placeholder="서비스 가능 지역을 입력하는 곳 입니다." class="input">
                      <div class="lp-box" v-if="boxes.length>0">
                        <div v-for="(box, box_idx) in boxes" :key="`box-${box_idx}`"
                             @click="selectBox(box)">{{ box.full_text }}
                        </div>
                      </div>
                    </div>
                  </div>
                </admin-form-item>
              </div>
              <div class="column is-full" v-if="isInternalPlugin('partner_video')">
                <admin-form-item label="공간 파트너 동영상">
                  <lp-input-video :file.sync="partner.video"></lp-input-video>
                </admin-form-item>
              </div>
              <div class="column is-full">
                <admin-form-item label="공간 파트너 대표 이미지" :desc="getRatio('partner_card')">
                  <drag-img-single :img.sync="partner.first_img"></drag-img-single>
<!--                  <input-img :url.sync="partner.first_img" :idx="1231111231"></input-img>-->
                </admin-form-item>
              </div>
              <div class="column is-full">
                <admin-form-item label="공간 파트너 이미지" :desc="getRatio('partner_detail_slider')">
                  <drag-img-multiple :imgs.sync="partner.imgs"></drag-img-multiple>
                  <!--<input-img-multiple
                    :images.sync="partner.imgs"
                    class="item"></input-img-multiple>-->
                </admin-form-item>
              </div>
              <div class="column is-full">
                <admin-form-item label="공간 파트너 한줄소개">
                  <input class="input"
                         :value="partner.simple_desc"
                         @input="e => partner.simple_desc = e.target.value"
                         placeholder="공간 파트너 관련 간단한 소개를 하는 곳 입니다."
                         type="text" maxlength="70">
                </admin-form-item>
              </div>
              <div class="column is-full">
                <admin-form-item label="공간 파트너 상세소개">
                  <lp-editor :text.sync="partner.info"></lp-editor>
                </admin-form-item>
              </div>
            </div>
          </admin-box-item>
        </div>

        <div class="box" v-if="isInternalPlugin('sns_inquiry')">
          <admin-box-item title="SNS 문의 전환 설정" subtitle="공간 파트너에게 문의할 수 있는 SNS 채널을 선택하고 링크를 입력합니다.">
            <admin-form-item label="SNS 채널">
              <div class="columns is-multiline" style="margin-top:0">
                <div class="column is-6">
                  <lp-check-bool :checked-val.sync="partner.enable_naver"
                                 label="네이버블로그"></lp-check-bool>
                  <input class="input"
                         style="margin-top:8px"
                         :value="partner.naver"
                         @input="e => partner.naver = e.target.value"
                         type="text"
                         maxlength="50">
                </div>
                <div class="column is-6">
                  <lp-check-bool :checked-val.sync="partner.enable_kakao"
                                 label="카카오톡"></lp-check-bool>
                  <input class="input"
                         style="margin-top:8px"
                         :value="partner.kakao"
                         @input="e => partner.kakao = e.target.value"
                         type="text"
                         maxlength="50">
                </div>
                <div class="column is-6">
                  <lp-check-bool :checked-val.sync="partner.enable_instagram"
                                 label="인스타그램"></lp-check-bool>
                  <input class="input"
                         style="margin-top:8px"
                         :value="partner.instagram"
                         @input="e => partner.instagram = e.target.value"
                         type="text"
                         maxlength="50">
                </div>
                <div class="column is-6">
                  <lp-check-bool :checked-val.sync="partner.enable_homepage"
                                 label="홈페이지"></lp-check-bool>
                  <input class="input"
                         style="margin-top:8px"
                         :value="partner.homepage"
                         @input="e => partner.homepage = e.target.value"
                         type="text"
                         maxlength="50">
                </div>
              </div>
            </admin-form-item>
          </admin-box-item>
        </div>

        <div class="box" v-if="!isLaunchpack">
          <admin-box-item title="운영시간 정보">
            <div class="columns is-multiline">
              <div class="column is-full">
                <operating-time-info ref="time_info"
                                     :bsnhour="partner.company_operating"
                                     style="position: relative"></operating-time-info>
              </div>
            </div>
          </admin-box-item>
        </div>

        <!-- 간편 공간 상품 -->
        <div class="box">
          <admin-box-item title="간편 공간 상품 등록"
            :tip="'공간 파트너의 상품을 빠르게 등록하기 위한 패널로, 간소화된 항목만이 입력 가능합니다.\n\n' +
              `- 새 간편 공간 상품 추가 : '상품 종류', '문의 전환', '주문 전환'은 서비스에 설정된 기본값을 따르게 됩니다.\n` +
              '- 공간 파트너 정보와 동일한 상품 추가 : 공간 파트너 정보와 동일한 내용이 등록됩니다.'">
            <simple-space-product :products="products"
                            :partner="partner"
                            @getData="getData"></simple-space-product>
          </admin-box-item>
        </div>

        <div class="box">
          <admin-box-item title="상품 공통 고시 정보"
            tip="공간 파트너 상품 등록 시 상품 정보, 배송안내, 교환/반품 안내 등 별도로 고시할 정보로, 공간 파트너의 모든 상품에 공통적으로 적용되며 상품등록 페이지에서 개별 고시 정보를 사용할 수 있습니다.">
            <div class="columns is-multiline">
              <div class="column is-full">
                <admin-form-item>
                  <div class="prod-reg-content">
                    <div class="flex" style="font-size: .9rem;">
                      <div class="lp-tab"
                           :class="{'lp-tab-selected':selectedTab===0}"
                           @click="selectedTab=0">상품 정보 제공 고시
                      </div>
                      <div class="lp-tab"
                           :class="{'lp-tab-selected':selectedTab===1}"
                           @click="selectedTab=1">배송안내
                      </div>
                      <div class="lp-tab"
                           :class="{'lp-tab-selected':selectedTab===2}"
                           @click="selectedTab=2">교환 및 반품안내
                      </div>
                    </div>
                    <div class="lp-tab-content">
                      <div v-show="selectedTab === 0">
                        <lp-editor :text.sync="partner.product_common_info.use_info"></lp-editor>
                      </div>
                      <div v-show="selectedTab === 1">
                        <lp-editor :text.sync="partner.product_common_info.delivery_info"></lp-editor>
                      </div>
                      <div v-show="selectedTab === 2">
                        <lp-editor :text.sync="partner.product_common_info.refund_info"></lp-editor>
                      </div>
                    </div>
                  </div>
                </admin-form-item>
              </div>
            </div>
          </admin-box-item>
        </div>

      </div>

      <div class="column is-5">

        <div class="box" v-if="isPartnerAdmin">
          <admin-box-item title="공간 파트너 관리자/담당자 정보"
                          :tip="'공간 파트너 페이지를 관리할 공간 파트너 담당자를 등록하세요.\n' +
                            '공간 파트너는 대표 공간 파트너 관리자와 일반 공간 파트너 유저로 구분 됩니다.\n' +
                            '* 대표 공간 파트너 관리자는 공간 파트너 관리 페이지의 정보를 수정하며 관리할수 있습니다.\n' +
                            '* 일반 공간 파트너 유저는 공간 파트너 관리 페이지의 정보만 확인 할 수 있으며 수정은 불가능합니다.'">
            <!-- 선택된 유저 -->
            <div class="columns is-multiline"
                 v-for="(user, idx) in users"
                 :key="'user'+idx"
                 style="border: 1px solid #ddd; border-radius: 4px; position: relative; padding: 4px; margin: 0 0 20px">

              <i class="material-icons unselect"
                 @click="openDeleteUser(user,idx)"
                 style="position: absolute; top: 6px; right: 4px; font-size: 1rem; cursor: pointer" v-if="isAdmin">close</i>

              <div class="column is-full">
                <span>
                  <span class="size-13 weight-400" style="color: #363636;font-weight:700">공간 파트너 관리 담당자 등록</span>
                  <span class="size-10 sub4" style="margin-left:10px">담당자 계정을 등록하려면 먼저 회원으로 등록되어 있어야 합니다.</span>
                </span>
                <admin-form-item label="아이디(이메일)" style="margin-top:12px">
                  <!-- 공간 파트너 수정페이지일 경우 -->
                  <div v-if="visibleEmail(user)">{{ user.email }}</div>
                  <div v-show="user.is_new">
                    <lp-adm-drop-input :data.sync="manager_list"
                                       @onSelect="res=>selectUser(res, idx)"
                                       :selectVal="user.email"
                                       replace="email"
                                       ref="admin_input"
                                       width="250px"
                                       placeholder="회원에서 계정 검색" listAlign="left"
                                       style="display:inline-block; margin-right:4px;"></lp-adm-drop-input>
                  </div>
                </admin-form-item>
              </div>

              <div class="column is-full">
                <admin-form-item label="담당자 이름">
                  <input class="input"
                         style="width:250px"
                         :value="user.name"
                         @input="e => user.name = e.target.value"
                         placeholder="담당자 이름을 입력해주세요."
                         type="text">
                </admin-form-item>
              </div>

              <div class="column is-full">
                <admin-form-item label="담당자 직함">
                  <input class="input"
                         style="width:250px"
                         :value="user.position"
                         @input="e => user.position = e.target.value"
                         placeholder="담당자 직함을 입력해주세요"
                         type="text">
                </admin-form-item>
              </div>

              <div class="column is-full">
                <admin-form-item label="휴대전화번호">
                  <input class="input"
                         style="width:250px"
                         :value="user.phone"
                         @input="e => user.phone = e.target.value"
                         placeholder="012-3456-7890"
                         maxlength="13"
                         type="text">
                </admin-form-item>
              </div>

              <div class="column is-full">
                <admin-form-item label="업무용 메일">
                  <input class="input"
                         style="width:250px"
                         :value="user.work_email"
                         @input="e => user.work_email = e.target.value"
                         placeholder="launchpack@launchpack.co.kr"
                         type="text">
                </admin-form-item>
              </div>
              <div class="column is-full" v-show="!user.selected && user.id">
                <div class="btn-group-justify-end">
                  <button class="button" @click="clickPass(user, idx)" style="width:140px">비밀번호 변경하기</button>
                </div>
              </div>

              <div v-show="user.selected" class="column is-full">
                <div class="columns is-multiline">
                  <div class="column is-full">
                    <admin-form-item label="현재 비밀번호">
                      <input class="input"
                             style="width:250px"
                             :value="user.password"
                             @input="e => user.password = e.target.value"
                             placeholder="현재 비밀번호를 입력하세요."
                             type="password">
                    </admin-form-item>
                  </div>
                  <div class="column is-full">
                    <admin-form-item label="새 비밀번호">
                      <input class="input"
                             style="width:250px"
                             :value="user.new_password"
                             @input="e => user.new_password = e.target.value"
                             placeholder="새 비밀번호를 입력하세요."
                             type="password">
                    </admin-form-item>
                  </div>
                  <div class="column is-full">
                    <admin-form-item label="새 비밀번호 확인">
                      <input class="input"
                             style="width:250px"
                             :value="user.new_password_re"
                             @input="e => user.new_password_re = e.target.value"
                             placeholder="새 비밀번호를 입력하세요."
                             type="password">
                    </admin-form-item>
                  </div>
                  <div class="column is-full" @click="passwordModify(user)">
                    <div class="btn-group-justify-end">
                      <button class="button" style="width:140px">비밀번호변경 확인</button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div>
              <div class="column is-full">
                <admin-form-item>
                  <button class="button"
                          style="width:100%; background:whitesmoke;color: #787878;"
                          @click="addPartnerManager">+ 공간 파트너 담당자 추가
                  </button>
                </admin-form-item>
              </div>
            </div>

            <div class="column is-full" v-if="users.length>0" style="margin-top:12px">
              <admin-form-item label="대표 관리자 계정 선택" desc="담당자를 먼저 등록하고 그 중 대표 관리자를 선택합니다."
                               v-if="$store.getters.mode==='admin'" style="margin-left:-10px;">
                <lp-adm-drop-input :data.sync="isUsers" @onSelect="res=> partner.partner_admin_id = res.value"
                                   :selectVal="partnerManagerName"
                                   listAlign="left"
                                   width="250px"
                                   replace="email"
                                   style="display:inline-block;margin-right:4px;padding-bottom:8px;"></lp-adm-drop-input>
              </admin-form-item>
              <admin-form-item label="대표 관리자 계정" v-else style="margin-left:-10px;">
                <div style="display:inline-block;margin-right:4px;padding-bottom:8px">{{ partnerManagerName }}</div>
              </admin-form-item>
            </div>
          </admin-box-item>
        </div>

        <div class="box" v-if="is_modify">
          <admin-box-item title="공간 파트너 퍼포먼스 정보">
            <div class="columns is-multiline">
              <div class="column is-6" v-if="performance.product || performance.product===0">
                <div class="flex space-between">
                  <div>등록한 상품</div>
                  <div class="unselect"
                       style="text-decoration: underline;"
                       @click="routerPush(getPath(`service/product?partner=${partner.name}`))">{{ performance.product }}건</div>
                </div>
              </div>
              <div class="column is-6" v-if="performance.like || performance.like===0">
                <div class="flex space-between">
                  <div>상품 찜</div>
                  <div>{{ performance.like }}건</div>
                </div>
              </div>
              <div class="column is-6" v-if="performance.inquiry || performance.inquiry===0">
                <div class="flex space-between">
                  <div>상품 문의</div>
                  <div>{{ performance.inquiry }}건</div>
                </div>
              </div>
              <div class="column is-6" v-if="performance.review || performance.review===0">
                <div class="flex space-between">
                  <div>상품 후기</div>
                  <div>{{ performance.review }}건</div>
                </div>
              </div>
              <div class="column is-6" v-if="performance.share || performance.share===0">
                <div class="flex space-between">
                  <div>상품 공유</div>
                  <div>{{ performance.share }}건</div>
                </div>
              </div>
              <div class="column is-6" v-if="performance.product_call || performance.product_call===0">
                <div class="flex space-between">
                  <div>전화 연결</div>
                  <div>{{ performance.product_call }}건</div>
                </div>
              </div>
              <div class="column is-6" v-if="performance.order || performance.order===0">
                <div class="flex space-between">
                  <div>견적 주문</div>
                  <div>{{ performance.order }}건</div>
                </div>
              </div>
              <div class="column is-6" v-if="performance.request || performance.request===0">
                <div class="flex space-between">
                  <div>견적 요청</div>
                  <div>{{ performance.request }}건</div>
                </div>
              </div>
              <div class="column is-6" v-if="performance.order_request || performance.order_request===0">
                <div class="flex space-between">
                  <div>상품 주문 신청</div>
                  <div>{{ performance.order_request }}건</div>
                </div>
              </div>
              <div class="column is-6" v-if="performance.order_success || performance.order_success===0">
                <div class="flex space-between">
                  <div>상품 주문 완료</div>
                  <div>{{ performance.order_success }}건</div>
                </div>
              </div>
            </div>
          </admin-box-item>
        </div>

        <div class="box" v-if="$store.getters.mode==='admin' && is_modify">

          <admin-box-item title="공간 파트너 히스토리 정보">
            <div class="columns is-multiline">
              <div class="column is-full">
                <admin-form-item label="관리자용 로그 및 메모" tip="관리자만 확인할 수 있는 메모를 별도로 입력할 수 있으며, 고객 특이사항 등을 입력할 수 있습니다.">
                  <admin-log-memo :memoLogsValue.sync="memo_logs"
                                  :newMemoValue.sync="newMemo"
                                  placeholder="공간 파트너 관련 간단메모를 입력하는 곳 입니다."
                                  @onClickHistoryBtn="clickHistoryBtn">
                  </admin-log-memo>
                </admin-form-item>
              </div>
            </div>
          </admin-box-item>
        </div>

        <!-- 맞춤 DB -->
        <div class="box" v-if="partner_param.length > 0">
          <admin-box-item title="맞춤 DB">
            <div class="columns is-multiline">
              <div class="column is-full"
                   v-for="(param, index) in partner_param"
                   v-bind:key="'param_input'+index">
                <admin-form-item :label="param.name">
                  <input-param :param.sync="param"></input-param>
                </admin-form-item>
              </div>
            </div>
          </admin-box-item>
        </div>
      </div>

    </div>

    <div class="btn-group-justify-end">
      <div class="button is-primary" @click="submit" v-if="isPartnerAdmin">저장하기</div>
    </div>

    <modal name="deleteUserModal" :adaptive="true" :width="600" height="auto" class="modal-style">
      <div class="lp-modal-wrapper">
        <div>지정한 공간 파트너 유저를 삭제하시겠습니까?</div>
        <div class="btn-group-justify-end">
          <button class="button is-light" @click="$modal.hide('deleteUserModal')">취소</button>
          <button class="button is-primary" @click="delUser">확인</button>
        </div>
      </div>
    </modal>

  </div>
</template>

<script>
  import draggable from 'vuedraggable'
  import moment from 'moment'
  import Datepicker from 'vuejs-datepicker'
  import {SweetModal} from 'sweet-modal-vue'
  import InputImg from '../../module/common/InputImg'
  import LpSelect from '../../module/common/LpSelect.vue'
  import LpInputText from '../../module/common/LpInputText'
  import LpSortDropDown from '../../module/common/LpSortDropDown'
  import LpAddress from '../../module/common/LpAddress'
  import LpCheckBool from '../../module/common/LpCheckBool'
  import LpRadio from '../../module/common/LpRadio'
  import LpRegionDropDown from '../../module/common/LpRegionDropDown'
  import OperatingTimeInfo from "../../module/common/OperatingTimeInfo";
  import LpEditor from "../../module/common/LpEditor";
  import LpAdmDropInput from "../../module/common/LpAdmDropInput";
  import AdminLogMemo from '../../module/common/AdminLogMemo'
  import InputParam from "../../module/custom/InputParam";
  import PartnerBusiness from "../../module/custom/PartnerBusiness";
  import SimpleSpaceProduct from "../../module/custom/SimpleSpaceProduct";
  import CreateMixin from "@/mixins/CreateMixin"
  import LpInputVideo from "../../module/common/LpInputVideo";
  import DragImgMultiple from "../../module/common/DragImgMultiple";
  import DragImgSingle from "../../module/common/DragImgSingle";

  export default {
    name: 'PartnerCreate',
    layout: 'Main',
    components: {
      DragImgSingle,
      DragImgMultiple,
      LpInputVideo,
      SimpleSpaceProduct,
      PartnerBusiness,
      InputParam,
      LpAdmDropInput,
      LpEditor,
      draggable,
      OperatingTimeInfo,
      InputImg,
      SweetModal,
      LpSelect,
      Datepicker,
      LpInputText,
      LpSortDropDown,
      LpAddress,
      LpCheckBool,
      LpRadio,
      LpRegionDropDown,
      AdminLogMemo
    },
    mixins: [
      CreateMixin
    ],
    mounted() {
      if (this.$store.getters.mode === 'admin' && this.$route.query.id) {
        this.is_modify = true;
        this.pass_ment = '비밀번호 변경시에만 입력하세요.';
      }
      else if (this.$store.getters.mode === 'space_partner') {
        this.is_modify = true;
      }
      this.social_key = this.$store.getters.backendData.social_key;
      //this.getPartnerGrade();
      this.getAbleVirtualCallNumber();

      this.getServiceRegion();
      this.getNormalUser();
      this.getData();
    },
    data() {
      return {
        menuTab: 1,
        // 맞춤 DB
        param_list: [],
        partner_param: [],
        // loading:false,
        // 서비스가능지역
        // 매핑할 지역이름
        map_region: '',
        // 상위선택지역 선택후 받은 지역의 구군 동
        region_store: [],
        boxes: [],
        tags: [],
        // 공간 파트너 등급 목록
        partnerGradeList: [],
        // 메모
        memo_logs: [],
        newMemo: '',
        selectedTab: 0,
        emailValid: false,
        tax_emailValid: false,
        pass_ment: '',
        // 현재페이지 등록:false, 수정:true
        is_modify: false,
        // 상품들
        products: [],
        visible_product: false,
        performance: {},
        // 공간 파트너 정보
        partner: {
          space: true,
          video: '',
          naver: '',
          instagram: '',
          kakao: '',
          homepage: '',
          enable_naver: false,
          enable_instagram: false,
          enable_kakao: false,
          enable_homepage: false,
          kakao_channel_id: '',
          partner_admin_id: '',
          simple_desc: '',
          name: '',
          phone: '',
          virtual_call_number: '',
          first_img: '',
          imgs: [],
          email: '',
          // 주소
          address: {
            sido: '',
            sigungu: '',
            dong: '',
            old: '',
            new: '',
            detail: '',
          },
          info: '',
          able_address: [],
          company_operating: [],
          product_common_info: {
            use_info: "",
            delivery_info: "",
            refund_info: ""
          },
        },
        //사업자 정보
        business: {
          name: '',
          phone: '',
          biz_number: '',
          biz_type: '',
          // 세금계산서 처리할 이메일
          is_tax_check: false,
          tax_email: '',
          // 정산 계좌
          bank_info: {
            bank: '',
            account_num: '',
            name: '',
          },
          // 등록증 사본
          img_registration: '',
          // 통장 사본
          img_bank_book: '',
          sign_price: 0,
          // 유료 공간 파트너 여부
          is_paid: false,
          // 수수료
          comm_start: '',
          comm_end: '',
          comm_rate: 0,
          is_comm: false,
          comm_price: 0,
          comm_type: 0,
          // 참여 기간
          joined_time: '',
          expired_time: '',
        },
        partnerTypeArr: [
          {label: '일반공간 파트너', value: 1},
          {label: '제휴공간 파트너', value: 0},
        ],
        //visible_user:false,
        // 유저들
        users: [],
        manager_list: [],
        able_virtual_call_number: undefined,
        disabledButton: false,
        social_key: {},
        deleteUserId: 0
      }
    },
    watch: {
      'partner.phone'(n) {
        let phone = autoHyphenPhone(this.partner.phone)
        if (!phone) {
          this.partner.phone = '';
        }
        else {
          this.partner.phone = phone;
        }
      },
      'partner.email'(n) {
        this.emailValid = this.validateEmail(n);
      },
      'business.tax_email'(n) {
        this.tax_emailValid = this.validateEmail(n);
      }
    },
    computed: {
      // 시간 정보
      timeInfo() {
        return ['월요일','화요일','수요일','목요일','금요일','토요일','일요일','공휴일'].map((i,idx) => {
          return {
            name: i,
            code: idx,
            is_closed: false,
            open_start: "",
            open_end: "",
            break_start: "",
            break_end: ""
          }
        });
      },
      pageDescription() {
        if(this.isAdmin) return '공간 파트너 정보를 등록합니다. 공간 파트너 등록시 필수 항목은 "공간 파트너명"입니다. \n' +
          '페이지를 관리할 공간 파트너 담당자를 추가하세요.';
        else {
          if(this.partner.partner_admin_id === this.$store.getters.partner.user_id)
            return '공간 파트너 정보를 수정합니다. 페이지를 관리할 공간 파트너 담당자를 추가하세요.'
          else return '공간 파트너 정보를 확인할 수 있습니다.';
        }
      },
      selectedGrade() {
        let grade = find(this.partnerGradeList, 'value', this.partner.grade);
        if(grade)
          return grade.label;
        else
          return '';
      },
      partnerManagerName() {
        let user = this.users.find(i => i.id === this.partner.partner_admin_id);
        return user ? user.email : '';
      },
      // 공간 파트너 담당자 추가하는 권한 체크
      isPartnerAdmin() {
        return this.$store.getters.mode === 'admin' ||
          (this.partner.partner_admin_id === this.$store.getters.partner.user_id);
      },
      isUsers() {
        return this.users.filter(i => i.email);
      },
    },
    methods: {
      clickPass(user, idx) {
        user.selected = true;
        this.users.push({});
        removeIndex(this.users,this.users.length-1);
      },
      // 관리자 공간 파트너 타입에 따라 구분
      visibleEmail(user) {
        if(this.isAdmin){
          return this.$route.query.id && !user.is_new;
        } else {
          return !user.is_new;
        }
      },
      // 공간 파트너 유저 비밀번호 변경
      passwordModify(user) {
        let err = '';
        if(user.password===undefined || user.password==='') err = '비밀번호를 입력하세요.';
        else if(user.new_password===undefined || user.new_password==='') err = '새 비밀번호를 입력하세요.';
        else if(user.new_password_re===undefined || user.new_password_re==='') err = '새 비밀번호 확인을 입력하세요.';

        else if(user.new_password!==user.new_password_re) err = '새 비밀번호를 다시 확인해주세요.';
        if(err) {
          this.toast(err);
          return;
        }

        this.$axios.post(this.getUrl(`member/user/${user.id}/check/password`), {
          password: user.password
        }).then(res=>{
          if(res.status===200){
            let data = {};
            data.username = user.email;
            data.password = user.new_password;
            this.$axios.patch(this.getUrl(`member/user/${user.id}`), data).then(res=>{
              if(res.status===200){
                user.selected = false;
                user.password = '';
                user.new_password = '';
                user.new_password_re = '';
                this.toast('비밀번호가 변경되었습니다.');
              }
            }).catch(error=>{
              if(error.response){
                this.toast('서버에 오류가 생겼습니다. 관리자에게 문의주세요');
              }
            })
          }
        }).catch(error=>{
          if(error.response){
            this.toast('비밀번호가 틀렸습니다. 다시 확인해주세요.');
          }
        })
      },
      paramAllList() {
        // 파라미터 리스트
        let url = '';
        if(this.isAdmin) url = this.getUrl('space/partner/param');
        if(!this.isAdmin) url = this.getUrl('space/param');
        this.$axios.get(url).then(res => {
          if (res.status === 200) {
            this.param_list = res.data;
            let result = this.paramChecker(this.param_list, this.partner_param)
            // console.log(result)
            if (result.length > 0) this.partner_param = this.partner_param.concat(result);
          }
        })
      },
      clickHistoryBtn(memo) {
        this.$axios.post(this.getUrl('space/partner/' + this.$route.query.id + '/memo'), {
          content: memo
        }).then(res => {
          if (res.status === 200) {
            let now = moment().format('YYYY-MM-DD HH:mm');
            let authorName = '';
            if (this.$store.getters.mode === 'admin') {
              authorName = this.$store.state.auth.admin.username;
            }
            else {
              authorName = this.$store.state.auth.partner.username;
            }
            this.memo_logs.splice(0, 0, {
              created_time: now,
              author: authorName,
              content: memo
            });
            this.newMemo = '';
            this.toast('로그가 저장되었습니다.');
          }
        });
      },
      getData() {
        this.getServiceRegion();
        //this.getPartnerGrade();
        this.getNormalUser();
        this.getAbleVirtualCallNumber();
        if (this.is_modify) {
          // 관리자
          let id = '';
          if (this.$store.getters.mode === 'admin') {
            id = this.$route.query.id;
          }
          // 공간 파트너
          else if (this.$store.getters.mode === 'space_partner') {
            id = this.$store.getters.partner.space_partner;
          }
          // this.loading=true;
          this.$axios.get(this.getUrl('space/partner/' + id)).then(res => {
            if (res.status === 200) {
              this.menuTab=1;
              this.performance = res.data.performance;
              this.partner = res.data.partner;
              if(res.data.params) {
                this.partner_param = res.data.params;
              }

              let business = res.data.business;

              if(!business.bank_info || !business.bank_info.bank) {
                business.bank_info = {
                  bank: '',
                  account_num: '',
                  name: '',
                }
              }
              this.business = business;
              let products = res.data.products;

              for (let i = 0; i < products.length; i++) {
                products[i].isNew = false;
              }
              this.products = products;
              if (res.data.partner.company_operating.length === 0) {
                this.partner.company_operating = this.timeInfo;
              }

              this.memo_logs = res.data.memo_logs;
              if (!this.partner.address) {
                this.partner.address = {
                  sido: '',
                  sigungu: '',
                  dong: '',
                  detail: '',
                  post_code: '',
                  old: '',
                  new: ''
                }
              }
              if (!res.data.partner.product_common_info) {
                this.partner.product_common_info = {
                  use_info: "",
                  delivery_info: "",
                  refund_info: ""
                }
              }
              let users = res.data.users;
              users.forEach(user=>{
                user.selected=false;
              })
              this.users = users;

              if(!this.isLaunchpack)
                this.paramAllList();
              this.initializeData();
            }
          });
        }
        else {
          if(!this.isLaunchpack)
            this.paramAllList();
          this.partner.company_operating = this.timeInfo;
        }
      },

      // null값 -> '', []
      initializeData() {
        for(let key in this.partner) {
          if(this.partner[key] === null) {
            this.partner[key] = '';
          }
        }
      },

      submit() {
        if (this.is_modify) {
          this.saveData()
        }
        else {
          let err = '';
          if (!this.partner.name) err = '공간 파트너명을 입력해주세요.';
          else if(!this.partner.phone) err = '공간 파트너 대표 전화번호를 입력해주세요.';
          else if(!this.partner.email) err = '공간 파트너 이메일을 입력해주세요.';
          else if (this.partner.phone && this.partner.phone.split('-').length < 2) err = '공간 파트너 대표 전화번호를 알맞게 입력해주세요.';

          if (err) {
            this.toast(err);
          } else {
            this.saveData();
          }
        }
      },
      saveData() {
        let partner = this.partner;

        /* 이메일 입력 했을 경우 형식 체크 */
        if(this.partner.email.length > 0 && this.emailValid===false) {
          this.toast('이메일을 형식에 맞게 입력해주세요.');
          return;
        }

        if(this.business.tax_email && this.business.tax_email.length > 0 && this.tax_emailValid===false) {
          this.toast('이메일을 형식에 맞게 입력해주세요.');
          return;
        }

        /* 공간 파트너 담당자 선택되지 않을 경우 예외처리 */
        if (this.users.length > 0) {
          for (let i = 0; i < this.users.length; i++) {
            if (this.users[i].username === '') {
              this.toast('추가한 공간 파트너 담당자의 아이디를 선택해주세요.');
              return;
            }
          }
        }

        /* 간편 공간 조건 확인 */
        if (this.products.length > 0) {
          for (let i = 0; i < this.products.length; i++) {
            if (this.products[i].name === '') {
              this.toast('추가한 상품의 이름을 입력해주세요.');
              return;
            }
            else if (this.products[i].category1_id === '') {
              this.toast('추가한 상품의 카테고리를 선택해주세요.');
              return;
            }
          }
        }
        let users = this.cloneItem(this.users);
        users.forEach(user=>{
          if(user.password) delete user.password;
        })

        let params = {
          partner: partner,
          business: this.business,
          parent_user: this.parent_user,
          products: this.products,
          users: users,
          partner_admin: this.partner_admin,
          params: this.partner_param
        };

        this.partner.phone = this.partner.phone.replace(/-/gi, '');

        if (this.able_virtual_call_number) {
          if (this.able_virtual_call_number.indexOf('사용') > -1) {
            params.partner.virtual_call_number = false;
          } else {
            params.partner.virtual_call_number = this.able_virtual_call_number;
          }
        }
        let config = '';
        if(this.partner.video) {
          this.showProgressToast('공간 파트너 저장중..', 0);
          let vm = this;
          config = {
            onUploadProgress: (progressEvent)=> {
              let percentCompleted = Math.round( (progressEvent.loaded * 100) / progressEvent.total );
              vm.percentCompleted = percentCompleted;
              this.showProgressToast('공간 파트너 저장중..', percentCompleted);
            }
          }
        }
        else this.$store.commit('setLoading', true);
        let url = '';
        // 관리자
        if (this.$store.getters.mode === 'admin') {
          let url = this.getUrl('space/partner')

          if (this.is_modify) {
            this.$axios.patch(url + '/' + this.$route.query.id, params).then(res => {
              if (res.status === 200) {
                if(this.partner.video) this.closeProgressToast();
                else this.$store.commit('setLoading', false);
                this.toast('저장되었습니다.');
                this.getData();
                /*if (this.isAdmin)
                  this.$router.replace(this.getPath('partner'));*/
              }
            }).catch(error => {
              if(this.partner.video) this.closeProgressToast();
              else this.$store.commit('setLoading', false);
              if (error.response) {
                this.toast(error.response.data.message);
              }
            });
          }
          else {
            this.$axios.post(url, params).then(res => {
              if (res.status === 200) {
                if(this.partner.video) this.closeProgressToast();
                else this.$store.commit('setLoading', false);
                this.toast('저장되었습니다.');
                this.saveServiceGuide('partner')
                if (this.isAdmin)
                  this.$router.replace(this.getPath('space/partner'));
              }
            }).catch(error => {
              if(this.partner.video) this.closeProgressToast();
              else this.$store.commit('setLoading', false);
              if (error.response) {
                this.toast(error.response.data.message);
              }
            });
          }
        }
        // 공간 파트너
        else if (this.$store.getters.mode === 'space_partner') {
          url = this.getUrl('space/partner/' + this.$store.getters.partner.space_partner);

          this.$axios.patch(url, params).then(res => {
            if (res.status === 200) {
              if(this.partner.video) this.closeProgressToast();
              else this.$store.commit('setLoading', false);
              this.toast('저장되었습니다.');
              this.getData();
              /*if (this.isAdmin)
                this.$router.replace('/office/partner');*/
            }
          }).catch(error => {
            if(this.partner.video) this.closeProgressToast();
            else this.$store.commit('setLoading', false);
            if (error.response) {
              //console.log(error.response)
              if (error.response.data.message)
                this.toast(error.response.data.message);
              else if (error.response.data.detail)
                this.toast(error.response.data.detail);
            }
          });
        }
      },
      del() {
        this.$axios.delete('space/partner')
          .then(res => {
            if (res.status === 200) {
              this.$refs.deleteModal.close()
              setTimeout(res => {
                this.toast('삭제되었습니다.')
                this.$router.replace(this.getPath('space/partner'));
              }, 500);
            }
          });
      },

      // 유저 정보 가져오기
      getNormalUser() {
        this.$axios.get('admin/member/user/simple').then(res => {
          if (res.status === 200) {
            this.manager_list = res.data;
          }
        })
      },
      // 서비스 지역 리스트 가져오기
      getServiceRegion() {
        this.$axios.get('admin/address/default/all').then(res => {
          if (res.status === 200) {
            this.region_store = res.data;
          }
        })
      },
      // 공간 파트너 등급 가져오기
      /*getPartnerGrade() {
        if(this.isLaunchpack) return;
        let url = '';
        if(this.isAdmin) url = 'admin/partner/gradelist';
        else url = this.getUrl('gradelist');
        this.$axios.get(url).then(res => {
          if (res.status === 200) {
            this.partnerGradeList = res.data.map(i => {
               return {
                 label: i.name,
                 value: i.id
               }
             });
          }
        });
      },*/
      getAbleVirtualCallNumber() {
        let url = 'admin/service/virtualcall/able';
        if (!this.isAdmin)
          url = `partner/${this.$store.getters.partner.space_partner}/virtualcall/able`;

        this.$axios.get(url).then(res => {
          this.able_virtual_call_number = res.data.able_virtual_call_number;
          if (this.able_virtual_call_number.indexOf('사용 가능한') > -1) {
            this.disabledButton = true;
          }
        }).catch(err => {
            //console.log(err);
          }
        )
      },
      // 담당자 선택하기
      selectUser(res, idx) {
        let item = this.manager_list.filter(i => i.id === res.value).forEach(item => {
          item.is_new = true;
          item.selected = false;
          this.users[idx] = item;
        });

        this.users.push({});
        removeIndex(this.users, this.users.length-1);

        // 최초에 대표 공간 파트너 담당자 계정 없을 경우 추가
        if (!this.partner.partner_admin_id || this.users.length === 1) {
          this.partner.partner_admin_id = this.users[0].id;
        }
      },
      // 박스 지역 선택
      selectBox(box) {
        if (box) {
          this.map_region = '';
          const key = (box.sido_id ? 'sido' : box.sigungu_id ? 'sigungu' : 'dong') + '_id';
          let item = {
            full_text: box.full_text
          };
          item[key] = box[key];
          this.partner.able_address.push(item);

          this.boxes = [];
        }
      },
      // 매핑할주소 input에 주소를 적으면 region_store의 데이터와 matching
      mapping(map_region) {
        this.map_region = map_region;
        if (this.map_region !== '') {
          this.boxes = this.region_store.filter(i => i.full_text.match(map_region))
            .map(item => {
              let key = (item.sido_id ? 'sido' : item.sigungu_id ? 'sigungu' : 'dong') + '_id';
              let result = {
                full_text: item.full_text
              };
              result[key] = item[key];
              return result;
            });
        }
      },
      // 태그 삭제
      delTag(index) {
        this.partner.able_address.splice(index, 1);
      },
      openDeleteUser(user, idx) {
        if(user.is_new) removeIndex(this.users,idx);
        else {
          this.deleteUserId = user.id;
          this.$modal.show('deleteUserModal');
        }
      },
      // 공간 파트너 담당자 삭제
      delUser() {
        if(this.isAdmin && this.deleteUserId>0){
          this.$axios.delete(`admin/space/partner/${this.$route.query.id}/user/${this.deleteUserId}`).then(res=>{
            if(res.status===200) {
              this.toast('공간 파트너 유저를 삭제하였습니다.');
              let userIndex = this.users.findIndex(i => i.id === this.deleteUserId);
              if(userIndex>-1) {
                removeIndex(this.users, userIndex);
                // 삭제중 공간 파트너 관리자일 경우
                if(this.deleteUserId===this.partner.partner_admin_id) {
                  // 공간 파트너 유저가 있을 경우 다음 공간 파트너 유저를 관리자로 변경
                  this.partner.partner_admin_id = this.users.length > 0 ? this.users[0].id : '';

                  // 공간 파트너 관리자 저장
                  this.$axios.patch(`admin/space/partner/${this.$route.query.id}/admin/change`, {
                    partner_admin_id: this.partner.partner_admin_id
                  });
                }
              }
              this.deleteUserId = 0;
              this.$modal.hide('deleteUserModal');
            }
          })
        }
      },
      // 공간 파트너 담당자 추가
      addPartnerManager() {
        this.users.push({
          name: '',
          position: '',
          phone: '',
          work_email: '',
          email: '',
          is_new: true
        });

      }
    }
  }
</script>

<style lang="stylus" type="stylus" scoped>
  @import '~assets/css/lp_main'

  .modal-address
    display flex
    flex-wrap wrap
    background whitesmoke
    padding 4px

  .lp-box
    position absolute
    background white
    z-index 1
    top 30px
    margin-top 8px
    border 1px solid #eee
    border-radius 3px
    padding 12px
    max-height 180px
    overflow-y auto

  .lp-box > div
    cursor pointer

  .lp-box > div:hover
    color $primary

  .modal-tag
    margin-right 4px
    margin-bottom 4px
    padding 5px 12px 4px 12px
    border 1px solid #eee
    border-radius 4px
    background white

  .modal-tag i
    margin-left 8px
    font-size 0.9rem

  .modal-input-mapping
    margin-top 3px
    width 100%
    border 0
    background #f2f7f8
    font-size 0.9rem

  .lp-tab
    display flex
    padding 10px 24px
    color #555

  .lp-tab-selected
    border: 1px solid #ccc;
    border-bottom: 1px solid #fff;
    color: #555;
    border-radius: 3px;

  .modal-container
    padding 20px;

  .menu-tab
    color white
    background-color $primary
    border-radius 16px

  .tab
    margin-right 12px
    padding 4px 8px
    cursor pointer
    font-weight bold

  .tab:last-child
    margin-right 0
</style>
